"use client";

import { useParams, usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import type IFeatureFlags from "src/lib/types/IFeatureFlags";

const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;


type ScriptOnNavProps = {
    featureFlags?: IFeatureFlags;
}

//#region [Component]
export default function ScriptOnNav({ featureFlags }: ScriptOnNavProps) {
    return <>
        {BRAND === "filmweb" && <AtmngScript />}
        <SeenThisScript featureFlags={featureFlags} />
    </>
}

function AtmngScript() {
    const pathname = usePathname();

    useEffect(() => {
        const isStreaming = pathname?.startsWith('/streamingguide');
        const scriptId = 'atmng-script';

        // Remove existing script if any
        const existing = document.getElementById(scriptId);
        if (existing) {
            existing.remove();
        }

        // Create new script
        const script = document.createElement('script');
        script.id = scriptId;
        script.src = isStreaming
            ? 'https://t.atmng.io/filmweb/IvYQJt7vE.prod.js'
            : 'https://t.atmng.io/filmweb/vqcMX_bYS.prod.js';
        script.async = true;
        script.defer = false;
        try {
            document.body.appendChild(script);
        } catch (e) {
            console.error("Error injecting script", e);
        }

        // Optional cleanup if you want to remove it on unmount
        return () => {
            script.remove();
        };
    }, [pathname]);

    return null;
}

function SeenThisScript({ featureFlags }: ScriptOnNavProps) {
    const pathname = useParams();
    const pathName = usePathname();
    const [stateTrigger, setStateTrigger] = useState(0);



    useEffect(() => {
        const adTargetsIds = document ? Array.from(document.querySelectorAll('.adnun'))
            .map(el => el.id)
            .filter(id => id) : null;

        //console.debug("%cSeenThisScript", "color: white; background: red", featureFlags?.executeSeenThisScript, adTargetsIds?.length);
        if (featureFlags?.executeSeenThisScript && (adTargetsIds?.length ?? 0) > 0) {

            console.debug("%cSeenThis", "color: white; background: indigo", adTargetsIds);
            // Create new script
            window.highImpactJs = window.highImpactJs || { cmd: [] };
            window.highImpactJs.cmd.push(() => {
                window.highImpactJs.setConfig({
                    plugins: ['adn'],
                    zIndex: 100000, //Max Z-index on your page
                });
                window.highImpactJs.setTemplateConfig("midscroll", {
                    topBarHeight: 0, // Height in px for the topbar (optional)
                    peekAmount: '100vh', // How much of the ad that should be visible
                    zIndex: 100001, // Z-index for the ad
                });

                const adUnitIdsByTemplate: { [key: string]: string[] } = {
                    midscroll: adTargetsIds!
                };

                const defineSlots = (template: string, sizes: number[][], waitForAdSignal: boolean) => {
                    (adUnitIdsByTemplate[template] || []).forEach(adUnitId => {
                        window.highImpactJs.defineSlot({ template, sizes, adUnitId, waitForAdSignal });
                    });
                };
                defineSlots("midscroll", [[1920, 1080], [1080, 1920]], true);
            });

            const scriptId = 'seenthis-script';
            // Remove existing script if any
            const existing = document.getElementById(scriptId);
            if (existing) {
                existing.remove();
            }

            // Create new script
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = "https://video.seenthis.se/public/patrik/filmweb/high-impact_adnuntius.min.js"
            script.async = true;
            script.defer = false;
            document.head.prepend(script);

            const eventListener = () => {
                setStateTrigger(new Date().getDate());
            }

            window.addEventListener("adtargets:ready", eventListener);

            // Optional cleanup if you want to remove it on unmount
            return () => {
                window.removeEventListener("adtargets:ready", eventListener);
                script.remove();
            };
        }
    }, [pathname, featureFlags?.executeSeenThisScript, pathName, stateTrigger]);

    return null;


}